import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_STATUS,
  RESET_STATUS,
  FETCH_REFERRAL_CATEGORIES_SUCCESS,
  SET_ERROR,
  UNASSIGN_KEYWORD_SUCCESS,
  FETCH_REFERRAL_CATEGORY_SUCCESS,
  FETCH_UNASSIGNED_KEYWORDS,
  ASSIGN_KEYWORDS_SUCCESS,
  UNASSIGN_ALL_KEYWORDS_SUCCESS,
  RESET_CURRENT_REFERRAL_INFO,
  FETCH_ACTIONS
} from "./referralCategoriesSagas";

export const initialState = {
  isLoading: true,
  referralCategories: [],
  currentReferralInfo: null,
  unassignedKeywords: [],
  actions: {},
  status: "idle",
  errors: null
};

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      status: action.payload
    }),
    [RESET_STATUS]: (state) => ({
      ...state,
      status: "idle",
      errors: null
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_REFERRAL_CATEGORIES_SUCCESS]: (state, action) => ({
      ...state,
      referralCategories: action.payload
    }),
    [RESET_CURRENT_REFERRAL_INFO]: (state) => ({
      ...state,
      currentReferralInfo: null
    }),
    [FETCH_REFERRAL_CATEGORY_SUCCESS]: (state, action) => ({
      ...state,
      currentReferralInfo: action.payload
    }),
    [FETCH_ACTIONS]: (state, action) => ({
      ...state,
      actions: action.payload
    }),
    [FETCH_UNASSIGNED_KEYWORDS]: (state, action) => ({
      ...state,
      unassignedKeywords: action.payload
    }),
    [ASSIGN_KEYWORDS_SUCCESS]: (
      state,
      { payload: { referralCategoryId, selectedUnassignedKeywords } }
    ) => {
      return {
        ...state,
        referralCategories: state.referralCategories.map((category) =>
          category.id === referralCategoryId
            ? {
                ...category,
                clientsCount:
                  category.clientsCount +
                  selectedUnassignedKeywords.reduce((acc, val) => (acc += val.clientsCount), 0),
                keywordsCount: category.keywordsCount + selectedUnassignedKeywords.length
              }
            : category
        ),
        currentReferralInfo: {
          ...state.currentReferralInfo,
          data: [...state.currentReferralInfo.data, ...selectedUnassignedKeywords]
        },
        unassignedKeywords: state.unassignedKeywords.filter(
          (unassignKeyword) => selectedUnassignedKeywords.indexOf(unassignKeyword) == -1
        )
      };
    },
    [UNASSIGN_KEYWORD_SUCCESS]: (
      state,
      { payload: { referralCategoryId, id, name, clientsCount } }
    ) => {
      return {
        ...state,
        referralCategories: state.referralCategories.map((category) =>
          category.id === referralCategoryId
            ? {
                ...category,
                clientsCount: category.clientsCount - clientsCount,
                keywordsCount: category.keywordsCount - 1
              }
            : category
        ),
        currentReferralInfo: {
          ...state.currentReferralInfo,
          data: state.currentReferralInfo.data.filter((referral) => referral.id !== id)
        },

        unassignedKeywords: [...state.unassignedKeywords, { id, name, clientsCount }]
      };
    },
    [UNASSIGN_ALL_KEYWORDS_SUCCESS]: (state, { payload: { id, referralInfo } }) => {
      return {
        ...state,
        referralCategories: state.referralCategories.map((category) =>
          category.id === id
            ? {
                ...category,
                clientsCount: 0,
                keywordsCount: 0
              }
            : category
        ),
        currentReferralInfo:
          state.currentReferralInfo && state.currentReferralInfo.id == id
            ? { id, data: [] }
            : state.currentReferralInfo,
        unassignedKeywords: [
          ...state.unassignedKeywords,
          ...(referralInfo ? referralInfo : state.currentReferralInfo.data)
        ]
      };
    }
  },

  initialState
);
